export default __webpack_public_path__ + "static/media/brand-1.dd47a3ff.png";